import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "on-focus__popular-list q-d-grid"
}
const _hoisted_2 = { class: "autocomplete-popup__popular-products-container q-row q-position-relative q-pt-0" }

import ProductsList from "./ProductsList.vue";
import PromotedProductContainer from '../PromotedProduct/PromotedProductContainer.vue'
import {defineProps} from "vue/dist/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsContainer',
  props: ['sectionEnabled', 'promotedProductEnabled', 'promotedProduct', 'promotedProductHeader', 'productsHeader', 'productsList', 'canShowPromotedSection'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (__props.sectionEnabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.promotedProduct && __props.promotedProductEnabled && __props.canShowPromotedSection)
            ? (_openBlock(), _createBlock(PromotedProductContainer, {
                key: 0,
                "promoted-product": __props.promotedProduct,
                "promoted-product-header": __props.promotedProductHeader
              }, null, 8, ["promoted-product", "promoted-product-header"]))
            : _createCommentVNode("", true),
          _createVNode(ProductsList, {
            "products-header": __props.productsHeader,
            "products-list": __props.productsList,
            "promoted-product-enabled": __props.promotedProductEnabled,
            "can-show-promoted-section": __props.canShowPromotedSection
          }, null, 8, ["products-header", "products-list", "promoted-product-enabled", "can-show-promoted-section"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})